import {httpRequest} from '../config/axios';
export async function getOpsConsolidatedData({pageIndex, pageSize, filters}) {
  const data = {
    date: {from: null, to: null},
    filters: {},
    page: pageIndex + 1,
    limit: pageSize,
  };
  filters.forEach((filter) => {
    if (filter?.id === 'Date') {
      const [from, to] = filter?.value || [];
      data.date.from = from;
      data.date.to = to;
    } else if (filter.id === 'Channel' && filter?.isApplied) {
      if (Array.isArray(filter?.value) && filter?.value.length > 0) {
        data.filters.channelCode = [];
        data.filters.channelGroupCode = [];
        filter?.value?.forEach((channel) => {
          const [channelGroupCode, channelCode] = channel?.split('-') || [];
          data.filters.channelCode.push(channelCode);
          data.filters.channelGroupCode.push(channelGroupCode);
        });
      }
    } else if (filter.id === 'Group By' && filter?.isApplied) {
      data.groupBy = {
        code: [],
        name: [],
      };
      const appliedGroupBy = filter?.value?.split(':');
      appliedGroupBy?.forEach((value) => {
        const [code, name] = value.split('-');
        data.groupBy.code.push(code);
        data.groupBy.name.push(name);
      });
    } else if (filter?.isApplied) {
      data.filters[filter?.key] = filter?.value;
    }
  });
  if (!(data.date.to && data.date.to)) return {rows: [], pageCount: 0};
  const response = await httpRequest.post('/get-consolidated-data', data);
  return {
    rows: response?.data?.data?.data?.list || [],
    totalCount: response?.data?.data?.data?.totalCount || null,
    totalOpsCount: response?.data?.data?.data?.totalOpsCount,
  };
}
